module.exports = __webpack_public_path__ + "assets/img/2bbcfede23e8363af39ce5c8c4648732.png";